import { render, staticRenderFns } from "./ModalSendMailType.vue?vue&type=template&id=7ebc69e0&scoped=true"
import script from "./ModalSendMailType.vue?vue&type=script&lang=js"
export * from "./ModalSendMailType.vue?vue&type=script&lang=js"
import style0 from "./ModalSendMailType.vue?vue&type=style&index=0&id=7ebc69e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebc69e0",
  null
  
)

export default component.exports